import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import { toast } from "react-toastify";
import { useForm, Controller } from "react-hook-form";
import axios from 'axios';

function Formulario(props) {
  const [loading, setLoading] = useState(true);
  const [pdfsEnabled, setPdfsEnabled] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const { control, handleSubmit, formState: { errors }, watch, reset, setValue } = useForm();

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const anexosValue = watch("anexos");

  useEffect(() => {
    if (anexosValue && anexosValue.value === "si") {
      setPdfsEnabled(true);
    } else {
      setPdfsEnabled(false);
      setSelectedFiles([]);
      setValue("pdfs", []);
    }
  }, [anexosValue, setValue]); 

  const onSubmit = async (data) => {
    let body = {
      numero_factura_sap: data.invoice,
      anexos:'NO',
      files_anexos: null,
      observacion: data.description ? data.description : '',
      tipo:'DOCSUPPORT' 
    };
    try {
      setLoading(true);
      const result = await axios.post(`https://2uj5iipka9.execute-api.us-east-1.amazonaws.com/dev/outsource/supportdoc`, body);
      setLoading(false);
      if (result.data.status) {
        toast.success(result.data.body.message);
        reset();
        setPdfsEnabled(false);
        setSelectedFiles([]); 
        setValue("invoice", "");
        setValue("anexos", null);
        setValue("pdfs", []);
        setValue("description", "");
      } else {
        toast.error(result.data.body.message);
        setLoading(false);
      }
    } catch (error) {
      toast.error("Algo salió mal.");
      setLoading(false);
    }
  };

  return loading ? (
    <div className="cargando">
      <div className="loader" id="loader">
        Loading...
      </div>
    </div>
  ) : (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <hr style={{ borderTop: "1px solid #dcdcdc", margin: "20px 0" }} />
        <h1 className="formulario">Formulario envío facturas</h1>
        <Row className={"contenedorF-Filtrado mbottom-20"}>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Form.Group className="inputmayuscula">
              <Form.Label className="texto-label">Ingresa Número Documento Soporte</Form.Label>
              <Controller
                name="invoice"
                control={control}
                rules={{ required: "El campo es obligatorio" }}
                render={({ field: { onChange, onBlur, value } }) => (
                  <Form.Control
                    type="number"
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.value)}
                    value={value}
                    className="centered-input"
                  />
                )}
              />
              {errors.invoice && (
                <Form.Text id="passwordHelpBlock" className="error">
                  El campo es obligatorio
                </Form.Text>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className={"contenedorF-Filtrado mbottom-10"}>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Form.Group>
              <Form.Label className="texto-label">Ingresa Comentarios ( Opcional ) </Form.Label>
              <Controller
                name="description"
                control={control}
                render={({ field: { onChange, onBlur, value } }) => (
                  <Form.Control
                    as="textarea"
                    rows={3}
                    onBlur={onBlur}
                    onChange={(e) => onChange(e.target.value)}
                    value={value}
                  />
                )}
              />
              {errors.description && (
                <Form.Text id="passwordHelpBlock" className="error">
                  El campo es obligatorio
                </Form.Text>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className={"mtop-10"}>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Button
              type="submit"
              variant="primary"
              className="btn btn-primary boton"
              style={{ width: "100%" }}
            >
              Crear
            </Button>
          </Col>
        </Row>

        <hr style={{ borderTop: "1px solid #dcdcdc", margin: "20px 0" }} />
      </form>
      <style jsx>{`
        .centered-input {
          text-align: center;
        }
      `}</style>
    </>
  );
}

export default Formulario;
